/** @format */

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
	selectCircleData,
	selectCircleExpectedTotalPayOut,
	selectIsLoading,
} from "../../redux/selectors/circleSelector";
import { AppDispatch } from "../../redux/store/store";
import { useParams } from "react-router-dom";
import { BootstrapDialog } from "../modal/notification-modal/styles";
import LoadingSpinner from "../loading-spinner/LoadingSpinner";
import { Container, Grid, Stack, Typography } from "@mui/material";
import { colors } from "../../utility/types/constant";
import {
	getCurrentCycleOfCircle,
	getContributionCycleById,
} from "../../redux/actions/contributionAction";
import { selectCurrentCycleOfCircle } from "../../redux/selectors/contributionSelector";
import ExpectedContributionAmountCard from "./ExpectedContributionAmount";
import ExpectedTotalContributionLightCard from "./ExpectedTotalContributionLightCard";
import ExpectedTotalPayOutLightCard from "./ExpectedTotalPayOutLightCard";
import { getCircleExpectedTotalPayOut } from "../../redux/actions/circleAction";

interface MoreCircleDetailsProps {
	open: boolean;
	handleClose: () => void;
	circleId?: string;
}

const MoreCircleDetails = (props: MoreCircleDetailsProps) => {
	const { open, handleClose } = props;
	const { circleId } = useParams();
	const dispatch = useDispatch<AppDispatch>();
	const circleData = useSelector(selectCircleData);
	const isLoading = useSelector(selectIsLoading);
	const selectedCircle = circleData;

	const currentCycle = useSelector((state: any) =>
		selectCurrentCycleOfCircle(state, circleData?._id ?? ""),
	);
	const circleContributionAmount =
		selectedCircle?.configuration?.contributionAmount;
	console.log("circleContributionAmount ====>", circleContributionAmount);
	const expectedTotalPayOut = useSelector(selectCircleExpectedTotalPayOut);
	const [showLoading, setShowLoading] = useState(false);

	useEffect(() => {
		if (circleData?._id) {
			dispatch(getCurrentCycleOfCircle({ unionId: circleData._id }));
		}
	}, [dispatch, circleData?._id]);

	useEffect(() => {
		if (currentCycle?._id) {
			dispatch(getContributionCycleById({ cycleId: currentCycle._id }));
		}
	}, [dispatch, currentCycle?._id]);

	useEffect(() => {
		let isMounted = true;

		const fetchBalance = async () => {
			if (circleId && currentCycle && currentCycle?._id) {
				try {
					setShowLoading(true);
					await dispatch(getCircleExpectedTotalPayOut({ unionId: circleId }));
					if (isMounted) {
						setShowLoading(false);
					}
				} catch (error: any) {
					if (isMounted) {
						setShowLoading(false);
					}
				}
			}
		};

		fetchBalance();

		return () => {
			isMounted = false;
		};
	}, [dispatch, circleId, currentCycle]);
	return (
		<React.Fragment>
			<BootstrapDialog
				open={open}
				onClose={handleClose}
				fullWidth
				maxWidth="lg">
				{isLoading ?
					<LoadingSpinner
						loading={isLoading}
						size={35}
						sx={{ mt: 5, mb: 5 }}
						color={colors.blue}
					/>
				:	<Container>
						<Stack
							direction="row"
							alignItems="center"
							justifyContent="center"
							mt={3}
							mb={3}>
							<Typography
								variant="h4"
								sx={{
									fontFamily: "'Montserrat', sans-serif",
									fontSize: "1rem",
									fontWeight: 999,
									textAlign: "center",
								}}></Typography>
						</Stack>

						<Stack
							alignContent="center"
							alignItems="center"
							direction="row"
							spacing={10}
							mt={5}
							mb={5}>
							<Grid item sm={6} xs={12} md={6} lg={12}>
								<ExpectedContributionAmountCard
									isLoading={isLoading}
									expectedContributionAmount={
										currentCycle && currentCycle._id ?
											(circleContributionAmount ?? "0")
										:	"0"
									}
								/>
							</Grid>
							<Grid item sm={6} xs={12} md={6} lg={12}>
								<ExpectedTotalPayOutLightCard
									isLoading={isLoading}
									expectedTotalPayOut={
										currentCycle && currentCycle._id ?
											(expectedTotalPayOut?.expectedTotalPayout ?? "0")
										:	"0"
									}
								/>
							</Grid>
							<Grid item sm={6} xs={12} md={6} lg={12}>
								<ExpectedTotalContributionLightCard
									isLoading={isLoading}
									expectedTotalContribution={
										currentCycle && currentCycle._id ?
											(expectedTotalPayOut?.expectedTotalPayout ?? "0")
										:	"0"
									}
								/>
							</Grid>
						</Stack>
					</Container>
				}
			</BootstrapDialog>
		</React.Fragment>
	);
};

export default MoreCircleDetails;
